module.exports = __webpack_public_path__ + "media/images/img/contact_kigyou-a2621851d8197b5c581fdfbdad67f035.jpg";